// extracted by mini-css-extract-plugin
export default {"crops__list":"CropsFilterList_crops__list__yjBa5","crops__list-empty":"CropsFilterList_crops__list-empty__ZuCm6"};